var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "toolbar-inner bottomToolbarInner" },
    _vm._l(_vm.bottomItemsData, function (item) {
      return _c(
        "a",
        {
          staticClass: "toolbarBlock",
          class: { common_toolbar: item.isSelected },
          style: _vm.backGroundClicked(item, item.active),
          attrs: { href: _vm.getLink(item.link, item.active), id: item.id },
          on: {
            click: function ($event) {
              return _vm.printBackground(item.link, item.active)
            },
          },
        },
        [
          _c("div", { staticClass: "toolbarBlockIconContainer" }, [
            _c("i", {
              staticClass: "icon toolbarBlockIcon",
              class: _vm.isWhite(item),
            }),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "toolbarBlockLabel",
              class: {
                label_toolbar_selected: item.isSelected,
                label_toolbar: !item.isSelected,
              },
              attrs: { id: item.idLabel },
            },
            [_vm._v("\n        " + _vm._s(_vm.$t(item.label)) + "\n   ")]
          ),
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }